<template>
	<section class="set-password container">
		<div class="col-12 text-center">
			<img src="../../../assets/images/logo-robo.png" alt="Riding out board online" style="width: 185px;">
		</div>
		<div class="col-12 text-center">
			<h1>Set Password</h1>
		</div>
		<div class="row">
			<div class="offset-md-4 col-md-4">
				<Form />
			</div>
		</div>
	</section>
</template>

<script>
import Form from "../SetPassword/Form";
export default {
	components: {
		Form
	}
}
</script>

<style lang="scss">
	.set-password {
		margin-top: 100px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Pages/SetPassword.vue